export default "__VITE_ASSET__CgsLAHm2__"